import ResultItemStyles from 'screens/blaze/Search/SearchModal/components/SearchResults/ResultItem.module.scss'
import SearchStyles from '../../Search.module.scss'
import Styles from './Loading.module.scss'
import { Skeleton } from 'antd'

export const Loading = () => (
  <div className={SearchStyles.itemsGrid}>
    <LoadingItem />
    <LoadingItem />
    <LoadingItem />
    <LoadingItem />
  </div>
)

const LoadingItem = () => {
  return (
    <div className={ResultItemStyles.searchResult}>
      <div className={ResultItemStyles.previewImage}>
        <Skeleton
          active
          className={Styles.preview}
          avatar={{ size: 160, shape: 'square', style: { borderRadius: 4 } }}
          title={false}
        />
      </div>
      <div className={ResultItemStyles.searchResultInfo}>
        <div className={ResultItemStyles.top}>
          <div className={ResultItemStyles.header}>
            <div className={ResultItemStyles.title}>
              <Skeleton className={Styles.title} active paragraph={{ rows: 1 }} title={false} />
            </div>
            <div className={ResultItemStyles.type}>
              <Skeleton className={Styles.type} active paragraph={{ rows: 1 }} title={false} />
            </div>
          </div>

          <div className={ResultItemStyles.summary}>
            <Skeleton className={Styles.summaryTop} active paragraph={{ rows: 1 }} title={false} />
            <Skeleton className={Styles.summaryBottom} active paragraph={{ rows: 1 }} title={false} />
          </div>
        </div>
        <div className={ResultItemStyles.footer}>
          <div className={ResultItemStyles.user}>
            <Skeleton
              active
              className={Styles.avatar}
              avatar={{ size: 24, shape: 'circle' }}
              paragraph={{ rows: 1, width: 150 }}
              title={false}
            />
          </div>
          <Skeleton active className={Styles.channel} avatar={{ size: 24, shape: 'square' }} title={false} />
        </div>
      </div>
    </div>
  )
}
